import styled, { css } from 'styled-components';
import { Text } from '../Text';
import { withMargins } from '../../mixins';
const getContainerStyleByState = (disabled, state) => {
    if (disabled)
        return css `
      background-color: var(--textinput-background-color-disabled);
      box-shadow: 0 0 0 var(--border-width-hairline) var(--textinput-border-color-disabled);
      cursor: not-allowed;
    `;
    if (state === 'error')
        return css `
      background-color: var(--textinput-background-color-error);
      box-shadow: 0 0 0 var(--border-width-hairline) var(--textinput-border-color-error);
    `;
    if (state === 'success')
        return css `
      background-color: var(--textinput-background-color-success);
      box-shadow: 0 0 0 var(--border-width-hairline) var(--textinput-border-color-success);
    `;
    return css `
    :hover {
      box-shadow: 0 0 0 var(--border-width-thin) var(--textinput-border-color-hover);
    }

    :focus-within {
      outline: var(--border-width-thin) solid var(--textinput-border-color-focus);
    }
  `;
};
export const ComponentWrapper = styled.div `
  ${({ display }) => display && `display: ${display}`};
  ${({ width }) => width && `width: ${width}`};
  ${withMargins}
`;
export const InputContainer = styled.span `
  width: 100%;
  display: inline-flex;
  align-items: center;
  border: none;
  border-radius: ${({ size }) => (size == 'medium' ? 'var(--border-radius-sm)' : 'var(--border-radius-xs)')};
  background-color: var(--textinput-background-color-base);
  color: var(--textinput-color-font);
  position: relative;
  z-index: var(--z-index-1-default, 1);

  box-shadow: ${({ hasContent }) => hasContent
    ? '0 0 0 var(--border-width-hairline) var(--textinput-border-color-filled)'
    : '0 0 0 var(--border-width-hairline) var(--textinput-border-color-empty)'};

  ${({ disabled, state }) => getContainerStyleByState(disabled, state)}
`;
export const InputField = styled.input `
  width: 100%;
  outline: none;
  border: none;
  background-color: inherit;
  font-family: var(--font-family);
  font-weight: var(--font-weight-regular);
  position: relative;

  ${({ variant }) => variant == 'medium'
    ? `
      font-size: var(--font-size-xs);
      padding: var(--spacing-1-5) var(--spacing-2);
      line-height: var(--font-lineheight-distant);
      border-radius: var(--border-radius-sm);
    `
    : `
      font-size: var(--font-size-xxs);
      padding: var(--spacing-0-5) var(--spacing-1);
      border-radius: var(--border-radius-xs);
    `};

  ::placeholder {
    color: var(--textinput-color-placeholder);
  }

  :disabled {
    cursor: not-allowed;
  }

  /* Chrome, Safari, Edge, Opera */
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
export const IconWrapper = styled.span `
  ${({ position, size }) => size == 'medium'
    ? `
      width: 24px;
      height: 24px;
      min-width: 24px;
      min-height: 24px;
      max-width: 24px;
      max-height: 24px;
      ${position === 'left' ? 'margin-left: var(--spacing-2);' : ''}
      ${position === 'right' ? 'margin-right: var(--spacing-2);' : ''}
    `
    : `
      width: 16px;
      height: 16px;
      min-width: 16px;
      min-height: 16px;
      max-width: 16px;
      max-height: 16px;
      ${position === 'left' ? 'margin-left: var(--spacing-1);' : ''}
      ${position === 'right' ? 'margin-right: var(--spacing-1);' : ''}
    `};
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: var(--textinput-icon-color);
    width: 100%;
    height: 100%;
  }
`;
export const SuperiorContentWrapper = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ size }) => (size == 'medium' ? 'var(--spacing-1)' : 'var(--spacing-0-5)')};
`;
export const FeedbackErrorMessage = styled.span `
  display: flex;
  margin-top: var(--spacing-1);

  * {
    color: var(--textinput-feedback-error-font-color);
  }
`;
export const TextError = styled(Text.Caption) `
  margin-left: var(--spacing-0-5);
  margin-right: var(--spacing-1);
  line-height: 18px;
`;
export const Icon = styled.div `
  width: 16px;
  height: 16px;
`;
export const Caption = styled(Text.Caption) `
  color: var(--textinput-caption-font-color);
`;
export const LimitText = styled.span `
  font-size: var(--font-size-xxxs);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-lineheight-medium);
  color: var(--color-neutral-120);
  margin-top: var(--spacing-1);
  margin-left: auto;
`;
